module.exports = __webpack_public_path__ + "static/media/mark-3.29bdd56f.png";